import {
    ApplicationInsights,
    IExtendedConfiguration,
    IExtendedTelemetryItem,
} from '@ms/1ds-analytics-js';
import { getClientVersion } from 'owa-config';
import { getVariantEnvironment } from 'owa-metatags';
import { getUserConfiguration } from 'owa-session-store';
import { CustomDataMap } from 'owa-analytics-actions';

const insights: { [tenant: string]: ApplicationInsights } = {};
export function logOneDSDatapoint(tenantToken: string, item: IExtendedTelemetryItem) {
    if (!insights[tenantToken]) {
        insights[tenantToken] = new ApplicationInsights();
        var config: IExtendedConfiguration = {
            instrumentationKey: tenantToken,
            endpointUrl: getCollectorUrl(),
        };

        insights[tenantToken].initialize(config);
        const context = insights[tenantToken].getPropertyManager().getPropertiesContext();
        if (context) {
            context.app.ver = getClientVersion();
            const userConfiguration = getUserConfiguration();
            if (userConfiguration) {
                context.user.locale = userConfiguration?.SessionSettings?.UserCulture;

                // TODO OW 87422
                // context.loc.tz = userConfiguration.UserOptions.TimeZone;
            }
        }
    }
    insights[tenantToken].track(item);
}

export function oneDSFlush() {
    Object.values(insights).forEach(analytics => {
        if (analytics) {
            analytics.getPostChannel().flush();
        }
    });
}

export function createEvent(eventName: string, props?: CustomDataMap): IExtendedTelemetryItem {
    return {
        name: eventName,
        data: props ? JSON.parse(JSON.stringify(props)) : {},
    };
}

function getCollectorUrl(): string | undefined {
    const environment = getVariantEnvironment();
    switch (environment) {
        case 'BlackForest':
            return 'https://emea.events.data.microsoft.com/Collector/3.0/';
        case 'GccHigh':
            return 'https://tb.events.data.microsoft.com/Collector/3.0/';
        case 'DoD':
            return 'https://pf.events.data.microsoft.com/Collector/3.0/';
        default:
            return undefined;
    }
}
